import { useEffect, useState } from "react"
import Select from 'react-select';
import { lang } from "../../../Utils";
import { createEnquiry, getAssets, getField, getMessage, getTopic } from "../Services";
import { ChakraProvider, Spinner, useBoolean, useDisclosure } from '@chakra-ui/react';
import Create from "./Create";
import { FeatureContext } from "../../../Context";
import FullPageLoader from "../../../components/loader/FullPageLoader";
import DialogMessage from "../../../components/dialog/DialogMessage";

const Index = () => {
  const { isOpen: isOpenSuccess, onOpen: onOpenSuccess, onClose: onCloseSuccess } = useDisclosure();
  const { isOpen: isOpenError, onOpen: onOpenError, onClose: onCloseError } = useDisclosure();
  const [loaderMessage, setLoaderMessage] = useBoolean();
  const [state, setState] = useState({
    topic: '',
    field: '',
    assets: '',
    message: '',
    topicList: [],
    fieldList: [],
    assetsList: [],
    loader: false,
    enquirId: '',
    setLoader: {
      on: () => setState(prevState => ({ ...prevState, loader: true })),
      off: () => setState(prevState => ({ ...prevState, loader: false })),
    },
    onFormSubmit: (formData) => onSubmit(formData),
  });

  useEffect(() => {
    getTopic()
      .then(data => setState(prevState => ({ ...prevState, topicList: data.reduce((arr, value) => [...arr, { value: value, label: lang(value) }], []) })))
      .catch(_ => setState(prevState => ({ ...prevState, topicList: [] })));
  }, []);

  const onChangeTopic = (value) => {
    setState(prevState => ({ ...prevState, topic: value, field: '', assets: '', message: '' }));
    getField(value.value)
      .then(data => setState(prevState => ({ ...prevState, fieldList: data.reduce((arr, value) => [...arr, { value: value, label: lang(value) }], []) })))
      .catch(_ => setState(prevState => ({ ...prevState, fieldList: [] })));
  }

  const onChangeField = (value) => {
    setState(prevState => ({ ...prevState, field: value, assets: '', message: '' }));
    getAssets(state.topic.value, value.value)
      .then(data => setState(prevState => ({ ...prevState, assetsList: data.reduce((arr, value) => [...arr, { value: value, label: lang(value) }], []) })))
      .catch(_ => setState(prevState => ({ ...prevState, fieldList: [] })));
  }

  const onChangeAssets = (value) => {
    setState(prevState => ({ ...prevState, assets: value, message: '' }));
    setLoaderMessage.on();
    getMessage(state.topic.value, state.field.value, value.value)
      .then(data => setState(prevState => ({ ...prevState, message: data })))
      .finally(_ => setLoaderMessage.off());
  }

  const onSubmit = (formData) => {
    console.log(state);
    state.setLoader.on();
    createEnquiry(formData)
      .then(response => {
        setState(prevState => ({...prevState, enquiryId: response.data.enquiryId}));
        onOpenSuccess();
        document.dispatchEvent(new Event('refresh-enquiries-list'));
      })
      .catch(error => {
        onOpenError();
      })
      .finally(_ => {
        setState(prevState => ({ ...prevState, topic: '', field: '', assets: '', message: '' }));
        state.setLoader.off()
      });

  }

  return (<ChakraProvider>
    <FeatureContext.Provider value={state}>
      {(!state.loader) ? <>
        <div className="bf-input-group">
          <label>{lang('Topic')}</label>
          <Select
            isDisabled={state?.topicList.length === 0}
            classNamePrefix="bf-select"
            value={state?.topic}
            onChange={(value) => onChangeTopic(value)}
            closeMenuOnSelect={true}
            options={state?.topicList} />
        </div>
        <div className="bf-input-group">
          <label>{lang('Field')}</label>
          <Select
            isDisabled={state?.fieldList.length === 0}
            classNamePrefix="bf-select"
            value={state?.field}
            onChange={(value) => onChangeField(value)}
            closeMenuOnSelect={true}
            options={state?.fieldList} />
        </div>
        <div className="bf-input-group">
          <label>{lang('Assets')}</label>
          <Select
            isDisabled={state?.assetsList.length === 0}
            classNamePrefix="bf-select"
            value={state?.assets}
            onChange={(value) => onChangeAssets(value)}
            closeMenuOnSelect={true}
            options={state?.assetsList} />
        </div>
        <div className="bf-enquiry-message">
          {(loaderMessage) ? <div className="bf-enquiry-message-loader"><Spinner /></div> : null}
          {(!loaderMessage && !!state.message?.message) ? <p dangerouslySetInnerHTML={{__html: lang(state.message.message)}}></p> : null}
          {(!loaderMessage && !!state.message.form && state.message?.form !== 'no-form') ? <p><Create /></p> : null}
        </div>
      </> : <FullPageLoader />}
      <DialogMessage
        isOpen={isOpenSuccess}
        onClose={onCloseSuccess}
        title={lang('Enquiry Create')}
        variant={'success'}>
        {lang('Your request has been sent successfully, it was created with this number') + ' ' + state.enquiryId}
      </DialogMessage>
      <DialogMessage
          isOpen={isOpenError}
          onClose={onCloseError}
          title={lang('Enquiry Create')}
          variant={'error'}>
          {lang('An error occurred while creating the request')}
        </DialogMessage>
    </FeatureContext.Provider>
  </ChakraProvider>)
}

export { Index }